import { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { FiSearch, FiMapPin } from "react-icons/fi";
import { Select } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Oval } from "react-loader-spinner";
// import required modules
import { Autoplay } from "swiper/modules";

// ------------------- cities
import cities from "../../constants/cities";
import { api } from "../../api/url";

// ------------------- css
import "./style.css";
import axios from "axios";

const swiperslides = [
  {
    src: require("../../assets/images/logos/shoride.png"),
    href: "/department/2",
  },
];

const LandingPage = () => {
  const [city, changeCity] = useState(236);
  const [search_val, changeSearch_val] = useState("");
  const [loading, changeLoading] = useState(false);
  const [doctors, changeDoctors] = useState([]);
  const [show_search_result, changeSearchResult] = useState(false);

  const CloseSearchResult = (e) => {
    changeSearchResult(false);
    changeDoctors([]);
  };

  const SearchMethod = async (val) => {
    await axios({
      method: "post",
      url: api + "appointment/attender/search/quick",
      data: {
        searchKey: val,
        cityId: city,
      },
    })
      .then((res) => {
        changeDoctors(res.data.data);
        changeLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        changeLoading(false);
      });
  };

  useEffect(() => {
    changeLoading(true);
    changeSearchResult(true);
    if (search_val) {
      const delayDebounceFn = setTimeout(() => {
        SearchMethod(search_val);
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      CloseSearchResult();
      changeLoading(false);
    }
  }, [search_val]);

  // -------------- change title
  document.title = "وبسلا، همراه شما در مسیر سلامتی";

  return (
    <>
      <div className="landingpage-section1">
        <h2>پذیرش آنلاین</h2>

        <p className=""> وِبسلا، همراه شما در مسیر سلامتی</p>

        <div className="landingpage-section1-operation ">
          <Select
            direction="ltr"
            suffixIcon={<FiMapPin style={{ fontSize: 20 }} />}
            style={{ width: 180, height: "100%" }}
            onChange={changeCity}
            value={city}
          >
            {cities.map((item) => (
              <Select.Option value={item.id}>{item.name}</Select.Option>
            ))}
          </Select>

          <div style={{ width: "100%" }}>
            <div className="searchbar">
              <FiSearch />
              <input
                // onBlur={() => CloseSearchResult()}
                // onFocus={() => changeSearchResult(true)}
                onChange={(e) => changeSearch_val(e.target.value)}
                placeholder="جستجو در بین پزشکان…"
              />
            </div>

            {show_search_result && (
              <div className="searchbar-dialog">
                {loading ? (
                  <div className="loading-container">
                    <Oval
                      visible={true}
                      height="35"
                      width="35"
                      strokeWidth={3}
                      color="#1E2B3B"
                      ariaLabel="oval-loading"
                      secondaryColor="#ACADAD"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                ) : doctors.length > 0 ? (
                  doctors.map((item) => {
                    return (
                      <div className="searchbar-dialog-content">
                        <a
                          href={"/doctors/" + item.attenderId}
                          className="searchbar-dialog-item"
                        >
                          <img
                            src={
                              item.genderId === 1
                                ? require("../../assets/images/man.png")
                                : require("../../assets/images/woman.png")
                            }
                          />
                          <div className="name">{item.attenderFullName}</div>
                          <div>-</div>
                          <span>{item.specialtyName}</span>
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className="loading-container">موردی یافت نشد!</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="landingpage-specialist-container">
        <h4 className="text-center">مراکز</h4>
        <Swiper
          breakpoints={{
            280: {
              slidesPerView: 1.5,
            },
            300: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1.5,
            },
            992: {
              slidesPerView: 4,
            },
          }}
          centerInsufficientSlides
          slidesPerView={5}
          spaceBetween={50}
          pagination={{
            clickable: true,
          }}
          // autoplay={{
          //   delay: 3000,
          //   disableOnInteraction: false,
          // }}
          // loop
          // modules={[Autoplay]}
          className="mySwiper"
        >
          {swiperslides.map((item) => (
            <SwiperSlide>
              <Link to={item.href} style={{ height: 150 }}>
                <img
                  style={{
                    height: 100,
                    width: "100%",
                    objectFit: "contain",
                  }}
                  src={item.src}
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div style={{ height: 100 }}></div>
    </>
  );
};

export default LandingPage;
